module.exports = __webpack_public_path__ + "static/img/bg-tit1.52b34a7c.webp";